import { cn } from '@/lib/utils'

interface FormSectionProps {
  title?: string
  description?: string
  children: React.ReactNode
  columns?: 1 | 2
  className?: string
}

export function FormSection({
  title,
  description,
  children,
  columns = 1,
  className,
}: FormSectionProps) {
  return (
    <div className={cn('py-5 first:pt-0 space-y-4', className)}>
      {title && (
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            {title}
          </p>
          {description && <p className="text-xs text-muted-foreground mt-1">{description}</p>}
        </div>
      )}
      <div
        className={cn('grid gap-4', columns === 2 ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1')}
      >
        {children}
      </div>
    </div>
  )
}
